export default [
  'ResourceService',
  class ClientAPIService {
    constructor (resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/clients';
    }

    getStore (client, store, cb = new Date().toString()) {
      if (!client || !store){
        return this._resourceService.errorPromise('clientAPI:getStore: missing parameters');
      }

      return this._resourceService.get(`${this._API_BASE}/${client}/stores/${store}?cb=${cb}`);
    }

    getCampaignsForStore (client, store, query) {
      if (!client || !store){
        return this._resourceService.errorPromise('clientAPI:getCampaignsForStore: missing parameters');
      }
      (query || (query = {}));

      return this._resourceService.get(`${this._API_BASE}/${client}/stores/${store}/campaigns`, {
        params: query,
        paramSerializer: '$httpParamSerializerJQLike'
      });
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/client-service.js